import { FiscalEmissionPointType } from "../@core/constants";

export class FiscalEmissionPoint {
    id: string;
    code: string;
    registerCode: string;
    fiscalEstablishment: string;
    salesOrg: string;
    name: string;
    processingStatus: string;
    processingMessage: string;
    timeStamp: Date;
    type: FiscalEmissionPointType;
    deleted: boolean;

    constructor() {
        this.id = "";
        this.code = "no fiscal";
        this.registerCode = "";
        this.fiscalEstablishment = "no fiscal";
        this.salesOrg = "";
        this.name = "";
        this.processingStatus = "";
        this.processingMessage = "";
        this.timeStamp = new Date();
        this.type = FiscalEmissionPointType.POS;
        this.deleted = false;
    }
}